import { useEffect, useState } from "react";
import { db } from "../../firebase";
import { collection, getDocs, doc, updateDoc } from "firebase/firestore";
import css from "./cartonchecss.module.css"; // стилі підключи за потреби
import Swal from "sweetalert2";

const EditSunSoonText = () => {
  const [soonText, setSoonText] = useState("");
  const [docId, setDocId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSoonText = async () => {
      const snapshot = await getDocs(collection(db, "seo"));
      if (!snapshot.empty) {
        const firstDoc = snapshot.docs[0];
        setSoonText(firstDoc.data().soon || "");
        setDocId(firstDoc.id);
      }
      setLoading(false);
    };

    fetchSoonText();
  }, []);

  const handleSave = async () => {
    if (!docId) return;

    try {
      const ref = doc(db, "seo", docId);
      await updateDoc(ref, { soon: soonText });
      Swal.fire("Готово!", "Текст успішно оновлено", "success");
    } catch (error) {
      console.error("Помилка оновлення тексту:", error);
      Swal.fire("Помилка", "Не вдалося оновити текст", "error");
    }
  };

  if (loading) return <p>Завантаження...</p>;

  return (
    <div className={css.editSoonWrap}>
      <h2>Редагування тексту "Незабаром"</h2>
      <textarea
        value={soonText}
        onChange={(e) => setSoonText(e.target.value)}
        rows={4}
        className={css.textareaSoon}
      />
      <button onClick={handleSave} className={css.saveButton}>
        Зберегти
      </button>
    </div>
  );
};

export default EditSunSoonText;
